<template>
  <div>
    <b-table
      hover
      responsive
      :items="eventList"
      :fields="tableColumns"
      class="event-table"
      :tbody-tr-class="rowClass"
    >
      <template v-slot:head(created)="scope">
        <div class="text-nowrap">Data złożenia wniosku</div>
        <div class="text-nowrap">Data weryfikacji</div>
      </template>
      <template v-slot:cell(name)="data">
        <router-link :to="`/certification/view/${data.item.id}`">
          <span class="event-table__event-name">
            {{ data.item.eventName }}
          </span>
          <span class="event-table__date-start">
            {{ duration(data.item.dateStart, data.item.dateEnd) }}
          </span>
          <span class="event-table__city">
            {{ data.item.city }}
          </span>
        </router-link>
      </template>

      <template v-slot:cell(applicantName)="data">
        <div class="event-table__applicant-name">
          {{ data.item.applicantName }}
        </div>
      </template>

      <template v-slot:cell(created)="data">
        <div>
          <span class="event-table__created-on">
            <Icon name="envelope" />
            {{ data.item.createdOn | moment("YYYY-MM-DD") }}
          </span>
        </div>
        <div v-if="data.item.approvedByFullname">
          <span class="event-table__approved-on">
            <Icon name="check" />
            {{ data.item.approvedOn | moment("YYYY-MM-DD") }}
          </span>
        </div>
      </template>

      <template v-slot:cell(certificateNo)="data">
        <span class="event-table__certificate-no">
          {{ data.item.certificateNo }}
        </span>
      </template>

      <template v-slot:cell(status)="data">
        <span class="event-table__status">
          {{ $t(`status_${data.item.status}`) }}
        </span>
        <span class="event-table__certification-status">
          {{ $t(`status_${data.item.certificationStatus}`) }}
        </span>
      </template>

      <template v-slot:cell(actions)="data">
        <Btn
          v-if="data.item.canOpen(user) && data.item.isClosed()"
          icon="lock"
          size="sm"
          variant="link-white"
          tooltip="Odblokuj certyfikat"
          @click="unlock(data.item.id)"
        />
        <Btn
          v-if="data.item.canClose(user) && !data.item.isClosed()"
          icon="unlock"
          size="sm"
          variant="link-white"
          tooltip="Zablokuj certyfikat"
          @click="lock(data.item.id)"
        />
        <Btn
          v-if="data.item.canUploadProgramme(user)"
          icon="cloud-upload"
          size="sm"
          variant="link-white"
          tooltip="Wyślij program szczegółowy"
          @click="uploadProgramme(data.item.id)"
        />
        <Btn
          v-if="data.item.isCompliant(user)"
          icon="medal"
          size="sm"
          variant="link-white"
          tooltip="Pobierz certyfikat"
          @click="getCertificate(data.item.certificateNo)"
        />
        <Btn
          v-if="data.item.canView(user)"
          icon="file-alt"
          size="sm"
          variant="link-white"
          tooltip="Zobacz"
          @click="view(data.item.id)"
        />
        <Btn
          v-if="data.item.canEdit(user)"
          icon="pen"
          size="sm"
          variant="link-white"
          :tooltip="editButtonText"
          @click="edit(data.item.id)"
        />
        <Btn
          v-if="data.item.canDelete(user)"
          icon="trash"
          size="sm"
          variant="link-white"
          tooltip="Usuń"
          @click="remove(data.item.id, data.item.eventName)"
        />
      </template>
    </b-table>

    <UploadModal
      v-model="uploadShow"
      :event-id="uploadEventId"
      @upload:success="reload"
    />
  </div>
</template>

<script>
import BaseEventResults from "./BaseEventResults";
import UserMixins from "./UserMixins";

export default {
  name: "UserEventResultsTable",
  extends: BaseEventResults,
  mixins: [UserMixins],
  data() {
    return {
      editButtonText: "Zmień",
      tableColumns: [
        { key: "name", label: "Wydarzenie" },
        { key: "applicantName", label: "Zgłaszający" },
        { key: "status", label: "Status" },
        { key: "certificateNo", label: "Certyfikat" },
        { key: "created", label: "Data złożenia wniosku\nData weryfikacji" },
        { key: "actions", label: "", class: "table__actions" }
      ]
    };
  }
};
</script>
